type ShipmentReferenceFields = {
  tracking_numbers?: string | null
  pro_number?: string | null
}

export function isActiveShipment(shipment: { status?: string | null }) {
  return !['canceled', 'cancelled'].includes(shipment.status ?? '')
}

/** Stored tracking numbers (a JSON list, or older plain text) as "1Z…, 1Z…". */
export function formatTrackingNumbers(value: string) {
  try {
    const parsed: unknown = JSON.parse(value)
    if (
      Array.isArray(parsed) &&
      parsed.length > 0 &&
      parsed.every((trackingNumber) => typeof trackingNumber === 'string')
    ) {
      return parsed.join(', ')
    }
  } catch {
    // Older shipments store a plain tracking number rather than JSON.
  }
  return value
}

/** The PRO, else the tracking number(s), a shipment is followed by. */
export function shipmentReference(shipment: ShipmentReferenceFields) {
  if (shipment.pro_number) return `PRO ${shipment.pro_number}`
  if (shipment.tracking_numbers) return formatTrackingNumbers(shipment.tracking_numbers)
  return null
}
